import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

// ── Inline SVG logos ────────────────────────────────────────────
const LogoFigma = () => (
  <svg viewBox="0 0 38 57" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="26">
    <path d="M19 28.5A9.5 9.5 0 1 1 28.5 19v19A9.5 9.5 0 0 1 19 28.5Z" fill="#1ABCFE"/>
    <path d="M0 47.5A9.5 9.5 0 0 1 9.5 38H19v9.5a9.5 9.5 0 1 1-19 0Z" fill="#0ACF83"/>
    <path d="M19 0v19h9.5a9.5 9.5 0 1 0 0-19H19Z" fill="#FF7262"/>
    <path d="M0 9.5A9.5 9.5 0 0 0 9.5 19H19V0H9.5A9.5 9.5 0 0 0 0 9.5Z" fill="#F24E1E"/>
    <path d="M0 28.5A9.5 9.5 0 0 0 9.5 38H19V19H9.5A9.5 9.5 0 0 0 0 28.5Z" fill="#A259FF"/>
  </svg>
);

const LogoReact = () => (
  <svg viewBox="-11.5 -10.23174 23 20.46348" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
    <circle cx="0" cy="0" r="2.05" fill="#61DAFB"/>
    <g stroke="#61DAFB" strokeWidth="1" fill="none">
      <ellipse rx="11" ry="4.2"/>
      <ellipse rx="11" ry="4.2" transform="rotate(60)"/>
      <ellipse rx="11" ry="4.2" transform="rotate(120)"/>
    </g>
  </svg>
);

const LogoTS = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
    <rect width="28" height="28" rx="4" fill="#3178C6"/>
    <path d="M15.5 20v-2.2c.5.3 1.1.5 1.8.5.9 0 1.3-.3 1.3-.8s-.3-.7-1.2-1.1l-.5-.2c-1.6-.6-2.4-1.5-2.4-2.8 0-1.5 1.2-2.6 3.1-2.6.8 0 1.5.1 2.1.4v2.1c-.5-.3-1.1-.4-1.7-.4-.8 0-1.2.3-1.2.8s.3.7 1.1 1l.5.2c1.7.7 2.5 1.5 2.5 2.9C20.9 19 19.6 20 17.5 20c-.8 0-1.5-.1-2-.3ZM13 11.1H7v1.8h2.1V20h2.2v-7.1H13v-1.8Z" fill="white"/>
  </svg>
);

const LogoVite = () => (
  <svg viewBox="0 0 256 257" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
    <defs>
      <linearGradient id="vg1" x1="-.828%" x2="57.636%" y1="7.652%" y2="78.411%">
        <stop offset="0%" stopColor="#41D1FF"/>
        <stop offset="100%" stopColor="#BD34FE"/>
      </linearGradient>
      <linearGradient id="vg2" x1="43.376%" x2="50.316%" y1="2.242%" y2="89.03%">
        <stop offset="0%" stopColor="#FF3CAC"/>
        <stop offset="100%" stopColor="#FF9A3C"/>
      </linearGradient>
    </defs>
    <path fill="url(#vg1)" d="M255.153 37.938 134.897 252.976c-2.483 4.44-8.862 4.466-11.382.048L.875 37.958c-2.746-4.814 1.371-10.646 6.827-9.67l120.385 21.517a6.537 6.537 0 0 0 2.322-.004l117.867-21.483c5.438-.991 9.574 4.796 6.877 9.62Z"/>
    <path fill="url(#vg2)" d="M185.432.063 96.44 17.501a3.268 3.268 0 0 0-2.634 3.014l-5.474 92.456a3.268 3.268 0 0 0 3.997 3.378l24.777-5.718c2.318-.535 4.413 1.507 3.936 3.838l-7.361 36.047c-.495 2.426 1.782 4.5 4.151 3.78l15.304-4.649c2.372-.72 4.652 1.36 4.15 3.788l-11.698 56.621c-.732 3.542 3.979 5.473 5.943 2.437l1.313-2.028 72.516-144.72c1.215-2.423-.88-5.186-3.54-4.672l-25.505 4.922c-2.396.462-4.435-1.77-3.759-4.114l16.646-57.705c.677-2.35-1.37-4.583-3.769-4.113Z"/>
  </svg>
);

const LogoClaude = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
    <rect width="24" height="24" rx="6" fill="#D97757"/>
    <path d="M8.5 16.5 12 7.5l3.5 9M9.8 13.5h4.4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const LogoFramer = () => (
  <svg viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="22">
    <path d="M0 0h14v7H7L0 0ZM0 7h7l7 7H0V7ZM0 14h7l-7 7v-7Z" fill="white"/>
  </svg>
);

const LogoTailwind = () => (
  <svg viewBox="0 0 54 33" fill="none" xmlns="http://www.w3.org/2000/svg" width="28" height="18">
    <path fillRule="evenodd" clipRule="evenodd" d="M27 0C19.8 0 15.3 3.6 13.5 10.8c2.7-3.6 5.85-4.95 9.45-4.05 2.054.513 3.522 2.004 5.147 3.653C30.744 12.672 33.514 15.6 40.5 15.6c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.513-3.522-2.004-5.147-3.653C36.756 2.928 33.986 0 27 0ZM13.5 15.6C6.3 15.6 1.8 19.2 0 26.4c2.7-3.6 5.85-4.95 9.45-4.05 2.054.514 3.522 2.004 5.147 3.653C17.244 28.272 20.014 31.2 27 31.2c7.2 0 11.7-3.6 13.5-10.8-2.7 3.6-5.85 4.95-9.45 4.05-2.054-.513-3.522-2.004-5.147-3.653C23.256 18.528 20.486 15.6 13.5 15.6Z" fill="#38BDF8"/>
  </svg>
);

// ── Animated counter ────────────────────────────────────────────
const Counter: React.FC<{ target: number; suffix?: string; duration?: number }> = ({
  target, suffix = '', duration = 1600
}) => {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [inView, target, duration]);

  return <span ref={ref}>{count}{suffix}</span>;
};

// ── Data ────────────────────────────────────────────────────────
const STATS = [
  { value: 72,   suffix: 'h',  label: 'competition window' },
  { value: 2011, suffix: '',   label: 'modules in final build' },
  { value: 5,    suffix: '',   label: 'screens shipped' },
  { value: 426,  suffix: 'kb', label: 'final bundle size' },
];

const STACK = [
  { name: 'Figma Make', sub: 'primary build tool', logo: <LogoFigma />, bg: '#1e1e1c' },
  { name: 'Claude',     sub: 'AI coding partner',  logo: <LogoClaude />, bg: '#2a1f1a' },
  { name: 'React',      sub: 'UI framework',       logo: <LogoReact />, bg: '#0d1f2d' },
  { name: 'TypeScript', sub: 'type safety',        logo: <LogoTS />, bg: '#0d1a2e' },
  { name: 'Vite',       sub: 'bundler',            logo: <LogoVite />, bg: '#1a0d2e' },
  { name: 'Tailwind v4',sub: 'styling',            logo: <LogoTailwind />, bg: '#0d2022' },
  { name: 'Framer Motion', sub: 'animations',      logo: <LogoFramer />, bg: '#1a0d2e' },
];

const REFLECTIONS = [
  {
    num: '01',
    title: 'AI doesn\'t replace design thinking — it accelerates it.',
    body: 'The constraint of a 72-hour window forced clarity. With Figma Make and Claude, I could iterate from concept to interactive prototype in hours. But the speed only worked because the design direction was sharp. Vague prompts produced noise. Clear intent produced product.',
  },
  {
    num: '02',
    title: 'Vibe coding is a real skill, and it\'s learnable.',
    body: 'Knowing how to prompt, when to correct, and how to steer an AI codebase is a distinct competency. I built 2011 modules, managed a Vite + React + Tailwind v4 stack, and shipped 5 interactive screens — not by writing every line, but by knowing exactly what each line should do.',
  },
  {
    num: '03',
    title: 'The line between designer and engineer is collapsing.',
    body: 'This project lived entirely at that boundary. The orb is a React component. The scroll section is physics. The Meera story is data + layout + motion. Tools like Figma Make prove that the designers who ship will be the ones who understand both sides of the stack.',
  },
];

// ── Component ───────────────────────────────────────────────────
const DriftReflections: React.FC = () => {
  const fadeUp = {
    hidden:  { opacity: 0, y: 32 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] as const } },
  };
  const stagger = {
    hidden:  { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };
  const staggerSlow = {
    hidden:  { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.18 } },
  };

  return (
    <section className="drift-reflect">

      {/* ── Header ── */}
      <motion.div
        className="drift-reflect-header"
        initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }}
        variants={stagger}
      >
        <motion.p className="drift-section-label drift-reflect-label" variants={fadeUp}>
          10 — Reflections
        </motion.p>
        <motion.h2 className="drift-reflect-headline" variants={fadeUp}>
          From prompt<br />to product.
        </motion.h2>
        <motion.p className="drift-reflect-sub" variants={fadeUp}>
          Built in a single competition weekend using Figma Make, Claude, and a stack I scaffolded entirely through AI-assisted development. This is what that looked like under the hood.
        </motion.p>
      </motion.div>

      {/* ── Stats ── */}
      <motion.div
        className="drift-reflect-stats"
        initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }}
        variants={stagger}
      >
        {STATS.map((s, i) => (
          <motion.div className="drift-reflect-stat" key={i} variants={fadeUp}>
            <span className="drift-reflect-stat-num">
              <Counter target={s.value} suffix={s.suffix} />
            </span>
            <span className="drift-reflect-stat-label">{s.label}</span>
          </motion.div>
        ))}
      </motion.div>

      {/* ── Tech stack ── */}
      <motion.div
        className="drift-reflect-stack-wrap"
        initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }}
        variants={stagger}
      >
        <motion.p className="drift-reflect-stack-heading" variants={fadeUp}>Stack</motion.p>
        <motion.div className="drift-reflect-stack" variants={stagger}>
          {STACK.map((t, i) => (
            <motion.div
              className="drift-reflect-pill"
              key={i}
              variants={fadeUp}
              style={{ '--pill-bg': t.bg } as React.CSSProperties}
              whileHover={{ y: -4, transition: { duration: 0.2 } }}
            >
              <div className="drift-reflect-pill-logo">{t.logo}</div>
              <div className="drift-reflect-pill-text">
                <span className="drift-reflect-pill-name">{t.name}</span>
                <span className="drift-reflect-pill-sub">{t.sub}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>

      {/* ── Reflections ── */}
      <motion.div
        className="drift-reflect-cards"
        initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }}
        variants={staggerSlow}
      >
        {REFLECTIONS.map((r, i) => (
          <motion.div className="drift-reflect-card" key={i} variants={fadeUp}>
            <span className="drift-reflect-card-num">{r.num}</span>
            <div className="drift-reflect-card-body">
              <h3 className="drift-reflect-card-title">{r.title}</h3>
              <p className="drift-reflect-card-text">{r.body}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

      {/* ── Closing ── */}
      <motion.div
        className="drift-reflect-close"
        initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }}
        variants={fadeUp}
      >
        <img src="/content/Drift/drift logo.svg" alt="drift" className="drift-reflect-close-logo" />
        <p>Submitted to FigBuild 2026 · Figma's annual student design-a-thon</p>
      </motion.div>

    </section>
  );
};

export default DriftReflections;
